import { getTemplates, getSearchedTemplates } from 'templates/api';
import { createWithEqualityFn } from 'zustand/traditional';
import { MasonryDataType } from './types';

type MasonryState = {
  masonryData: MasonryDataType | null;
  isLoading: boolean;
  fetchMasonryData: (
    category: string,
    subCategory: string,
    searchParams: URLSearchParams,
    segments?: string[],
  ) => Promise<void>;
  searchTemplates: (
    searchParams: URLSearchParams,
    segments?: string[],
    searchValue?: string,
  ) => Promise<void>;
};

const useMasonryDataStore = createWithEqualityFn<MasonryState>(set => ({
  masonryData: {
    nextPage: null,
    data: [],
    pages: null,
    total: null,
  },
  isLoading: true,
  fetchMasonryData: async (category, subCategory, searchParams, segments = []) => {
    set({ isLoading: true });

    const headers = {
      segments,
    };

    const masonryData = await getTemplates(category, subCategory, searchParams, headers);
    set({
      masonryData: {
        nextPage: masonryData.metadata?.next_page,
        pages: masonryData.metadata?.pages,
        data: masonryData.data,
      },
      isLoading: false,
    });
  },
  searchTemplates: async (searchParams, segments = []) => {
    try {
      set({ isLoading: true });
      const headers = {
        segments,
      };
      const masonryData = await getSearchedTemplates(searchParams, headers);
      set({
        masonryData: {
          nextPage: masonryData.metadata?.next_page,
          data: masonryData.response.items,
          pages: null,
          total: masonryData.response.total,
        },
        isLoading: false,
      });
    } catch (error) {
      set({ isLoading: false });
      console.error(error);
      throw new Error('Page not found');
    }
  },
}));

export default useMasonryDataStore;
